import Item from '@/models/Item';
import { getItemRequest } from '@/store/item/action';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

// Esse hooks é utilizado p fazer o polling enquanto o vídeo está em processamento
export const useEditVideo = (isEdit: boolean, newFileSelected: boolean, item?: Item) => {
    const dispatch = useDispatch();

    const isVideoProcess = (item: Item) => {
        return !item.path.startsWith('/static');
    };

    let interval: NodeJS.Timeout | undefined;

    const isVideoReady = isEdit && !newFileSelected && !!item && isVideoProcess(item);

    const clearConversionInterval = (): void => {
        if (interval) {
            clearInterval(interval);
            interval = undefined;
        }
    };

    useEffect(() => {
        if (isEdit && item && isVideoReady) {
            interval = setInterval(() => {
                dispatch(getItemRequest(Number(item.id), true));
            }, 3000);
        }
        if (!isVideoReady) {
            clearConversionInterval();
        }
        return () => {
            clearConversionInterval();
        };
    }, [dispatch, isVideoReady]);

    return {
        isVideoReady,
    };
};
